// extracted by mini-css-extract-plugin
export default {"deviceLink":"DashNavbar_deviceLink__1jVCi","icon":"DashNavbar_icon__ptunh","mdm":"DashNavbar_mdm__TITVA","trustedAccess":"DashNavbar_trustedAccess__H4c9G"};